import {useEffect} from 'react'

export interface UseKeyboardInteraction {
  ok?: () => void
  close?: () => void
}

export const useKeyboardInteraction = ({
  ok,
  close
}: UseKeyboardInteraction): void =>
  useEffect(() => {
    const fn = (e: KeyboardEvent) => {
      e.stopPropagation()
      e.preventDefault()

      if (e.key === 'Escape') {
        close?.()
      }
      if (e.key === ' ' || e.key === 'Space' || e.key === 'Enter') {
        ok?.()
      }
    }

    document.addEventListener('keydown', fn, {capture: true})
    return () => document.removeEventListener('keydown', fn, {capture: true})
  }, [close])
